import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AiStatusService {

    constructor(
        private apiService: ApiService,
        private toastrService: ToastrService
    ) {}

    getStatus(aiModel: string): Observable<any> {
        return this.apiService.getAiStatus(aiModel);
    }

    accept(aiModel: string): Observable<any> {
        return this.apiService.updateAiStatus(aiModel, 1);
    }

    reject(aiModel: string): Observable<any> {
        return this.apiService.updateAiStatus(aiModel, 0);
    }
}